
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/journal/author/[slug]",
      function () {
        return require("private-next-pages/journal/author/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/journal/author/[slug]"])
      });
    }
  